var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhiteWithBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 9.54692,
    fill: "url(#paint0_radial_53_393)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2491 29.595C15.4109 29.4401 15.6334 29.3498 15.8694 29.3498H37.2701C37.6612 29.3498 37.8567 29.8014 37.5803 30.066L33.3527 34.1114C33.1909 34.2663 32.9684 34.3566 32.7324 34.3566H11.3317C10.9406 34.3566 10.7451 33.905 11.0216 33.6404L15.2491 29.595Z",
    fill: "url(#paint1_radial_53_393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2489 14.4906C15.4174 14.3358 15.6399 14.2454 15.8692 14.2454H37.2699C37.6609 14.2454 37.8565 14.6971 37.58 14.9616L33.3525 19.0071C33.1907 19.1619 32.9682 19.2523 32.7322 19.2523H11.3315C10.9404 19.2523 10.7449 18.8006 11.0213 18.5361L15.2489 14.4906Z",
    fill: "url(#paint2_radial_53_393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3527 21.9944C33.1909 21.8395 32.9684 21.7492 32.7324 21.7492H11.3317C10.9406 21.7492 10.7451 22.2009 11.0216 22.4654L15.2491 26.5109C15.4109 26.6657 15.6334 26.756 15.8694 26.756H37.2701C37.6612 26.756 37.8567 26.3044 37.5803 26.0399L33.3527 21.9944Z",
    fill: "url(#paint3_radial_53_393)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_53_393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.2666 -9.06777) rotate(126.623) scale(121.001 214.476)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF25E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393725,
    stopColor: "#2B45D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886471,
    stopColor: "#23A9D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_53_393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3009 31.8532) rotate(13.7335) scale(23.1096 10.2742)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_53_393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3007 16.7488) rotate(13.7335) scale(23.1096 10.2742)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_53_393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3009 24.2526) rotate(13.7335) scale(23.1096 10.2742)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.8149,
    height: 20.1112,
    fill: "white",
    transform: "translate(10.8936 14.2454)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteWithBg);
export default __webpack_public_path__ + "static/media/logo-white-with-bg.86aabe7a60d7dbdb4690552c19b6840a.svg";
export { ForwardRef as ReactComponent };